import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { sendOfferFormSchema } from './send-offer-form.schema';

export const useSendOfferForm = () => {
  const form = useForm({
    resolver: yupResolver(sendOfferFormSchema),
    defaultValues: sendOfferFormSchema.cast({}),
  });

  return { form };
};
